export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
    },
  },
  {
    path: "/auth/callback",
    name: "auth-callback",
    component: () => import("../views/account/callback.vue"),
    meta: {
      title: "SSO Callback",
      authRequired: false,
    },
  },
  {
    path: "/",
    name: "default",
    meta: {
      title: "Home",
      authRequired: true,
      skipPrivilegeCheck: true,
    },
    component: () => import("../views/dashboard/index.vue"),
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout",
      authRequired: true,
    },
    component: () => import("../views/account/login.vue"),
  },
  {
    path: "/auth/lockscreen-basic",
    name: "lock-screen-basic",
    meta: {
      title: "Lock Screen",
      authRequired: true,
    },
    component: () => import("../views/auth/lockscreen/basic"),
  },
  {
    path: "/auth/lockscreen-cover",
    name: "lock-screen-cover",
    meta: {
      title: "Lock Screen",
      authRequired: true,
    },
    component: () => import("../views/auth/lockscreen/cover"),
  },
  {
    path: "/auth/404",
    name: "404",
    meta: {
      title: "Error 404",
      authRequired: true,
    },
    component: () => import("../views/auth/errors/404"),
  },
  {
    path: "/auth/403",
    name: "403",
    meta: {
      title: "Error 403",
      authRequired: true,
    },
    component: () => import("../views/auth/errors/403"),
  },
  {
    path: "/auth/500",
    name: "500",
    meta: {
      title: "Error 500",
      authRequired: true,
    },
    component: () => import("../views/auth/errors/500"),
  },
  {
    path: "/auth/404-basic",
    name: "404-basic",
    meta: {
      title: "Error 404",
      authRequired: true,
    },
    component: () => import("../views/auth/errors/404-basic"),
  },
  {
    path: "/auth/404-cover",
    name: "404-cover",
    meta: {
      title: "Error 404",
      authRequired: true,
    },
    component: () => import("../views/auth/errors/404-cover"),
  },
  {
    path: "/auth/ofline",
    name: "ofline",
    meta: {
      title: "Offline",
      authRequired: true,
    },
    component: () => import("../views/auth/errors/ofline"),
  },
  {
    path: "/auth/logout-cover",
    name: "logout-cover",
    meta: {
      title: "Logout",
      authRequired: true,
    },
    component: () => import("../views/auth/logout/cover"),
  },
  {
    path: "/auth/success-msg-basic",
    name: "success-msg-basic",
    meta: {
      title: "Success Message",
      authRequired: true,
    },
    component: () => import("../views/auth/success-msg/basic"),
  },
  {
    path: "/auth/success-msg-cover",
    name: "success-msg-cover",
    meta: {
      title: "Success Message",
      authRequired: true,
    },
    component: () => import("../views/auth/success-msg/cover"),
  },
  {
    path: "/sales-order",
    name: "sales-order",
    meta: {
      title: "Sales Order List",
      authRequired: true,
      page_code: "SALESV2-0002",
    },
    component: () => import("../views/sales_orders/index.vue"),
  },
  {
    path: "/sales-order/create",
    name: "sales-order-create",
    meta: {
      title: "Sales Order Create",
      authRequired: true,
      page_code: "SALESV2-0002",
      required_access: "create",
    },
    component: () => import("../views/sales_orders/create.vue"),
  },
  {
    path: "/sales-order/detail/:so_no(.*)",
    name: "sales-order-detail",
    meta: {
      title: "Sales Order Detail",
      authRequired: true,
      page_code: "SALESV2-0002",
    },
    component: () => import("../views/sales_orders/detail.vue"),
  },
  {
    path: "/tiro-order",
    name: "tiro-order",
    meta: {
      title: "Tiro Order",
      authRequired: true,
      page_code: "SALESV2-0003",
    },
    component: () => import("../views/tiro_orders/index.vue"),
  },
  {
    path: "/sales-order/stock-catalog",
    name: "sales-order-stock-catalog",
    meta: {
      title: "Stok & Harga Item",
      authRequired: true,
      page_code: "SALESV2-0002",
    },
    component: () => import("../views/sales_orders/stock_catalog.vue"),
  },
  {
    path: "/sales-order/guide",
    name: "sales-order-guide",
    meta: {
      title: "Panduan Penggunaan Sales Order",
      authRequired: true,
      skipPrivilegeCheck: true,
    },
    component: () => import("../views/sales_orders/guide.vue"),
  },
  {
    path: "/sales-orders/guide",
    redirect: "/sales-order/guide",
  },

  // SALES MEMO (PENGELUARAN TITIPAN)
  {
    path: "/sales-memos",
    name: "sales-memos",
    meta: {
      title: "Daftar Sales Memo",
      authRequired: true,
      page_code: "SALESV2-0005",
      required_access: "read",
    },
    component: () => import("../views/sales_memos/index.vue"),
  },
  {
    path: "/sales-memo",
    redirect: "/sales-memos",
  },
  {
    path: "/sales-memos/create",
    name: "sales-memo-create",
    meta: {
      title: "Buat Sales Memo",
      authRequired: true,
      page_code: "SALESV2-0005",
      required_access: "create",
    },
    component: () => import("../views/sales_memos/create.vue"),
  },
  {
    path: "/sales-memos/detail/:no(.*)",
    name: "sales-memo-detail",
    meta: {
      title: "Detail Sales Memo",
      authRequired: true,
      page_code: "SALESV2-0005",
      required_access: "read",
    },
    component: () => import("../views/sales_memos/detail.vue"),
  },
  {
    path: "/sales-memos/guide",
    name: "sales-memo-guide",
    meta: {
      title: "Panduan Penggunaan Sales Memo",
      authRequired: true,
      skipPrivilegeCheck: true,
    },
    component: () => import("../views/sales_memos/guide.vue"),
  },
  {
    path: "/sales-memo/guide",
    redirect: "/sales-memos/guide",
  },

  // PUSAT PANDUAN (GUIDANCE HUB)
  {
    path: "/guidance",
    name: "guidance-hub",
    meta: {
      title: "Pusat Panduan & Dokumentasi",
      authRequired: true,
      skipPrivilegeCheck: true,
    },
    component: () => import("../views/guidance/index.vue"),
  },
  {
    path: "/panduan",
    redirect: "/guidance",
  },
  {
    path: "/uat",
    name: "uat-hub",
    meta: {
      title: "Pusat Dokumen UAT",
      authRequired: true,
      skipPrivilegeCheck: true,
    },
    component: () => import("../views/uat/index.vue"),
  },
  {
    path: "/uat/:module",
    name: "uat-sheet",
    meta: {
      title: "Lembar Kerja & Berita Acara UAT",
      authRequired: true,
      skipPrivilegeCheck: true,
    },
    component: () => import("../views/uat/sheet.vue"),
  },
  {
    path: "/uat-form",
    redirect: "/uat",
  },
  {
    path: "/uat-scenarios",
    redirect: "/uat",
  },
  {
    path: "/qa-scenarios",
    redirect: "/uat",
  },
  {
    path: "/qa-matrix",
    redirect: "/uat",
  },

  // SALES PLAFOND LIST
  {
    path: "/sales-plafond",
    name: "sales-plafond",
    meta: {
      title: "Sales Plafond List",
      authRequired: true,
      page_code: "SALESV2-0001",
    },
    component: () => import("../views/sales_plafond/index.vue"),
  },

  // PENGAJUAN PLAFOND
  {
    path: "/pengajuan-plafond",
    name: "pengajuan-plafond",
    meta: {
      title: "Pengajuan Plafond",
      authRequired: true,
      page_code: "SALESV2-0001",
    },
    component: () => import("../views/pengajuan_plafond/index.vue"),
  },

  {
    path: "/pengajuan-plafond/choose-type",
    name: "PengajuanPlafondChooseType",
    meta: {
      title: "Pilih Jenis Pengajuan Plafond",
      authRequired: true,
      page_code: "SALESV2-0001",
      required_access: "create",
    },
    component: () => import("../views/pengajuan_plafond/choose-type.vue"),
  },

  {
    path: "/pengajuan-plafond/create",
    name: "PengajuanPlafondCreate",
    meta: {
      title: "Buat Pengajuan Plafond - Perubahan",
      authRequired: true,
      page_code: "SALESV2-0001",
      required_access: "create",
    },
    component: () => import("../views/pengajuan_plafond/create.vue"),
  },
  // {
  //   path: "/pengajuan-plafond/create-group-action",
  //   name: "PengajuanPlafondCreateGroupAction",
  //   meta: {
  //     title: "Buat Pengajuan Plafond - Group Action",
  //     authRequired: true,
  //     page_code: "SALESV2-0001",
  //     required_access: "create",
  //   },
  //   component: () => import("../views/pengajuan_plafond/create-group-action.vue"),
  // },

  {
    path: "/pengajuan-plafond/group-create",
    name: "group-plafond-create",
    meta: {
      title: "Buat Pengajuan Group Plafond",
      authRequired: true,
      page_code: "SALESV2-0001",
      required_access: "create",
    },
    component: () => import("../views/pengajuan_plafond/group-create.vue"),
  },
  {
    path: "/pengajuan-plafond/group-verification",
    name: "group-plafond-verification",
    meta: {
      title: "Verifikasi Pengajuan Group Plafond",
      authRequired: true,
      page_code: "SALESV2-0001",
      required_access: "create",
    },
    component: () => import("../views/pengajuan_plafond/group-verification.vue"),
  },
  {
    path: "/pengajuan-plafond/group-detail",
    name: "group-plafond-detail",
    meta: {
      title: "Detail Group Plafond",
      authRequired: true,
      page_code: "SALESV2-0001",
      required_access: "create",
    },
    component: () => import("../views/pengajuan_plafond/group-detail.vue"),
  },

  {
    path: "/pengajuan-plafond/extension",
    name: "PengajuanPlafondExtension",
    meta: {
      title: "Buat Pengajuan Plafond - Perpanjangan",
      authRequired: true,
      page_code: "SALESV2-0001",
      required_access: "create",
    },
    component: () => import("../views/pengajuan_plafond/extension.vue"),
  },

  {
    path: "/pengajuan-plafond/:id",
    name: "pengajuan-plafond-detail",
    meta: {
      title: "Detail Pengajuan Plafond",
      authRequired: true,
      page_code: "SALESV2-0001",
    },
    component: () => import("../views/pengajuan_plafond/detail.vue"),
  },

  {
    path: "/pengajuan-plafond/verification-result",
    name: "pengajuan-plafond-verification-result",
    meta: {
      title: "Hasil Verifikasi Pengajuan Plafond",
      authRequired: true,
      page_code: "SALESV2-0001",
    },
    component: () => import("../views/pengajuan_plafond/verification-result.vue"),
  },

  {
    path: "/pengajuan-plafond/verification-extension",
    name: "pengajuan-plafond-verification-extension",
    meta: {
      title: "Hasil Verifikasi Perpanjangan Plafond",
      authRequired: true,
      page_code: "SALESV2-0001",
    },
    component: () => import("../views/pengajuan_plafond/verification-extension.vue"),
  },

  // APPROVAL SUBSTITUTION

  {
    path: "/approval-substitution",
    name: "approval-substitution",
    meta: {
      title: "Approval Substitution",
      authRequired: true,
      page_code: "SALESV2-0010",
    },
    component: () => import("../views/approval_substitution/index.vue"),
  },

  {
    path: "/approval-substitution/create",
    name: "approval-substitution-create",
    meta: {
      title: "Approval Substitution",
      authRequired: true,
      page_code: "SALESV2-0010",
      required_access: "create",
    },
    component: () => import("../views/approval_substitution/create.vue"),
  },
  {
    path: "/approval-substitution/view/:id",
    name: "approval-substitution-view",
    meta: {
      title: "Edit Approval Substitution",
      authRequired: true,
      page_code: "SALESV2-0004",
      required_access: "update",
    },
    component: () => import("../views/approval_substitution/create.vue"),
  },

  // DISTRIBUTION PLAN (UNDER CONSTRUCTION)
  {
    path: "/distribution-plan",
    name: "distribution-plan-list",
    meta: {
      title: "Daftar Displan",
      authRequired: true,
      page_code: "SALESV2-0004",
      required_access: "read",
    },
    component: () => import("../views/distribution_plan/index.vue"),
  },
  {
    path: "/distribution-plan/create",
    name: "distribution-plan-create",
    meta: {
      title: "Buat Displan",
      authRequired: true,
      page_code: "SALESV2-0004",
      required_access: "create",
    },
    component: () => import("../views/distribution_plan/create.vue"),
  },
  {
    path: "/distribution-plan/approval",
    name: "distribution-plan-approval",
    meta: {
      title: "Approval Displan",
      authRequired: true,
      page_code: "SALESV2-0004",
      required_access: "approval",
    },
    component: () => import("../views/distribution_plan/index.vue"),
  },
  {
    path: "/distribution-plans/verify-bypass",
    name: "distribution-plan-verify-bypass",
    meta: {
      title: "Verifikasi Bypass Antrian DP",
      authRequired: false,
      skipPrivilegeCheck: true,
    },
    component: () => import("../views/distribution_plan/verify.vue"),
  },
  {
    path: "/distribution-plan/verify-bypass",
    redirect: (to) => {
      return { path: "/distribution-plans/verify-bypass", query: to.query };
    },
  },
  {
    path: "/distribution-plan/guide",
    name: "distribution-plan-guide",
    meta: {
      title: "Panduan Penggunaan Distribution Plan",
      authRequired: true,
      skipPrivilegeCheck: true,
    },
    component: () => import("../views/distribution_plan/guide.vue"),
  },
  {
    path: "/distribution-plans/guide",
    redirect: "/distribution-plan/guide",
  },
];
